/**
 * Check if `a` is one of `[...b]`
 */
export function isOneOf(a, b) {
    if (b === void 0) { b = []; }
    return b.some(function (v) { return a === v; });
}
//# sourceMappingURL=is-one-of.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/smooth-scrollbar/utils/is-one-of.js
// module id = 679
// module chunks = 0